/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{clamp as r}from"../../../utils/clamp.js";import{alpha as t,number as o}from"../numbers/index.js";import{sanitize as s}from"../utils.js";import{isColorString as m,splitColor as e}from"./utils.js";const a={...o,transform:t=>Math.round((t=>r(0,255,t))(t))},n={test:m("rgb","red"),parse:e("red","green","blue"),transform:({red:r,green:o,blue:m,alpha:e=1})=>"rgba("+a.transform(r)+", "+a.transform(o)+", "+a.transform(m)+", "+s(t.transform(e))+")"};export{a as rgbUnit,n as rgba};
//# sourceMappingURL=rgba.js.map
